import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import main from '../../img/Trading/main.png'

import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#131313]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between">
                <div className="flex flex-col items-start">
                    <Fade left><p className="text-[36px] xl:text-[64px] manrope text-white mt-[40px] xl:mt-[100px] font-[500] leading-[1.2] xl:max-w-[600px]">{t('trading.1')}</p></Fade>
                    <Fade left delay={200}><Button className={'mt-[40px] xl:mt-[60px]'} main/></Fade>
                </div>
                <Fade right delay={500}><img src={main} className="mt-[40px] xl:mt-0" alt="" /></Fade>
            </div>
        </div>
    );
}

export default Main;